import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { browserExtension } from 'utils/contentProvider';

const ExtensionLink = styled.a`
  display: inline-flex;
  text-decoration: none;
  background: linear-gradient(
    77.08deg,
    #6020ea 36.51%,
    rgba(96, 32, 234, 0.66) 69.52%
  );
  color: #fff;
  padding: 7px 12px;
  border-radius: 40px 1px 40px 40px;
  letter-spacing: 0.27px;
  margin-right: 24px;
  line-height: 1;
  align-items: center;
  vertical-align: middle;

  img {
    margin-right: 5px;
  }
`;

const ExtensionButton = ({ tooltipStyle = {} }) => (
  <ExtensionLink
    href={browserExtension.chromeLink}
    target="_blank"
    rel="noopener noreferrer"
    className="tooltip-container">
    <img src="/assets/img/chrome.svg" alt="chrome" width="20px" height="20px" />
    <span>Chrome Extension</span>
    <span
      className="tooltip"
      style={{ textTransform: 'none', top: -8, left: 50, ...tooltipStyle }}>
      Download Chrome extension to review web applications
    </span>
  </ExtensionLink>
);

ExtensionButton.propTypes = {
  tooltipStyle: PropTypes.object,
};

export default ExtensionButton;
